export default __webpack_public_path__ + "static/media/93626-coding.353bc61d.gif";